export class InvalidFormat extends TypeError {}

export default InvalidFormat;
